import { TARGET_GRADIENT_TOKENS } from '../common/SVGGradients/SVGGradients.content';
import { Breakpoint } from '../hooks/useBreakpoint/index.types';
import { COLOR_TOKENS, RESPONSIVE_TOKENS } from './index.content';

const appendColorVariables = (colorScheme: 'light' | 'dark') =>
  Object.entries(COLOR_TOKENS[colorScheme])
    .map((entry) => `--${entry[0]}: ${entry[1]};`)
    .join('');

const appendResponsiveVariables = (breakpoint: Breakpoint) =>
  Object.entries(RESPONSIVE_TOKENS)
    .reduce((accumuator: string[], outerEntry) => {
      return [
        ...accumuator,
        ...Object.entries(outerEntry[1]).map(
          (innerEntry) => `--${innerEntry[0]}: ${innerEntry[1][breakpoint]}px;`,
        ),
      ];
    }, [])
    .join('');

const appendSVGGradientClasses = (colorScheme: 'light' | 'dark') =>
  TARGET_GRADIENT_TOKENS.reduce(
    (accumulator, token) =>
      accumulator +
      `svg[data-gradient=${token}] [fill] { fill: url(#${token}-gradient-${colorScheme}); }` +
      `svg[data-gradient=${token}] [stroke] { stroke: url(#${token}-gradient-${colorScheme}); }`,
    '',
  );

export const injectStyles = () => `
  :root {
    ${appendColorVariables('light')}
    ${appendSVGGradientClasses('light')}
    ${appendResponsiveVariables(Breakpoint.DESKTOP)}
  }

  @media (prefers-color-scheme: dark) {
    :root {
      ${appendColorVariables('dark')}
      ${appendSVGGradientClasses('dark')}
    }
  }

  @media (max-width: 900px) {
    :root {
      ${appendResponsiveVariables(Breakpoint.TABLET)}
    }
  }

  @media (max-width: 600px) {
    :root {
      ${appendResponsiveVariables(Breakpoint.MOBILE)}
    }
  }
`;
